import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Product } from '@shared/models/product';
import { BcmCostCenter } from '@shared/models/bcm-cost-center';
import { ConfirmDialogService } from '@sharedComponents/dialogs/confirm-dialog/confirm-dialog.service';
import { TranslationService } from '@core/translation/translation.service';

// Cost-center selection rule for every product→position entry point:
// 0 -> null, exactly 1 -> auto-select, >1 -> open a selection dialog.
@Injectable({providedIn: 'root'})
export class CostCenterSelectionService {

    constructor(
        private confirmDialogService: ConfirmDialogService
    ) {
    }

    /**
     * @param promptOnMultiple Bei mehreren Kostenstellen nachfragen. Ist die Abfrage abgeschaltet
     *   (Rechnungsformular-Toggle), bleibt die Position ohne Kostenstelle – die eindeutige
     *   Zuordnung bei genau einer Kostenstelle greift weiterhin.
     */
    resolve(product: Product, promptOnMultiple = true): Observable<BcmCostCenter | null> {
        const costCenters = (product instanceof Product ? product.costCenters : null) || [];

        if (!costCenters.length) {
            return of(null);
        }

        if (costCenters.length === 1) {
            return of(costCenters[0]);
        }

        if (!promptOnMultiple) {
            return of(null);
        }

        return this.confirmDialogService
            .setTitle(TranslationService.translate('dialogs.productSubscription.addCostCenterTitle'))
            .setBody(TranslationService.translate('dialogs.productSubscription.addCostCenterBody'))
            .setFocusYesButtonOnOpen()
            .appendSelectToBody<BcmCostCenter>({
                name: 'costCenter',
                type: 'select',
                label: TranslationService.translate('dialogs.productSubscription.costCenterLabel'),
                list: costCenters,
                listAttribute: 'name',
                defaultValue: costCenters[0],
            })
            .openAndReturnResult<{ costCenter: BcmCostCenter }>()
            .pipe(map(result => result?.costCenter ?? null));
    }
}
